@if (!isAccessFlagLoading && !isUrlVerified) {
  <app-url-verification
    [hasAccess]="isAccessEnabled"
    [noAccessMessage]="featureFlagErrorText | translate"
    [tenantApiBaseUrl]="tenantService.BASE_URL"
    (successfulVerificationEvent)="onSuccessfulVerification()"
    (mustSignOutEvent)="signOut()"
  >
  </app-url-verification>
} @else {
  @if (!isAccessFlagLoading && !isLoading && user) {
    <div class="container">
      <app-banner
        [user]="user"
        [isAccessITPAdmin]="isAccessITPAdmin"
        [title]="bannerTitleKey | translate"
        [isWebApps]="isWebApps"
        [isVirtualPrinterOnly]="isVirtualPrinterOnly()"
        [hasWebCapture]="hasWebCaptureAccess() && webCaptureFeatureFlag()"
        [hasTranscriptProcessing]="transcriptProcessingFlag() && hasItpAccess()"
      >
      </app-banner>
      @if (hasWebCaptureAccess() && webCaptureFeatureFlag()) {
        <nav
          class="tab-navigation"
          role="navigation"
          aria-label="Main navigation"
        >
          <a
            class="dap-doc-upload-tab tab-link"
            tooltipPosition="bottom"
            showDelay="1000"
            tooltipEvent="both"
            [class.active]="currentTab === ''"
            [pTooltip]="'adHocUploadDescription' | translate"
            [attr.aria-current]="currentTab === '' ? 'page' : null"
            [routerLink]="['/webcapture']"
          >
            <i class="fa-solid fa-file"></i>
            <span>{{ 'documentUpload' | translate }}</span>
          </a>
          <a
            routerLink="batches"
            routerLinkActive="active"
            class="dap-batches-tab tab-link"
            tooltipPosition="bottom"
            showDelay="1000"
            tooltipEvent="both"
            [pTooltip]="'createBatchDescription' | translate"
          >
            <i class="fa-solid fa-rectangle-history-circle-plus"></i>
            <span>{{ 'documentBatching' | translate }}</span>
          </a>
        </nav>
      }

      <div class="router-container">
        @if (!isRestrictedRouteForVirtualPrinter) {
          <router-outlet></router-outlet>
        }
      </div>
    </div>
  }

  <p-confirmDialog
    #tabChangeDialog
    key="tabChangeDialog"
  >
    <ng-template
      let-message
      pTemplate="headless"
    >
      <div class="confirm-container">
        <div>
          <p>{{ message.message | translate }}</p>
        </div>
        <div class="buttons-container">
          <p-button
            class="dap-cancel-btn cancel-button"
            variant="text"
            [ariaLabel]="'cancel' | translate"
            [label]="'cancel' | translate"
            (click)="tabChangeDialog.onReject()"
          >
          </p-button>

          <p-button
            class="dap-confirm-btn confirm-button"
            [ariaLabel]="'confirm' | translate"
            [label]="'confirm' | translate"
            (click)="tabChangeDialog.onAccept()"
          >
          </p-button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog
    #closeBatchDialog
    key="closeBatchDialog"
  >
    <ng-template
      let-message
      pTemplate="headless"
    >
      <div class="confirm-container">
        <div>
          <p>{{ message.message | translate }}</p>
        </div>
        <div class="buttons-container">
          <p-button
            class="dap-cancel-close-batch cancel-button"
            variant="text"
            [ariaLabel]="'cancel' | translate"
            [label]="'cancel' | translate"
            (click)="closeBatchDialog.onReject()"
          >
          </p-button>

          <p-button
            class="dap-close-batch confirm-button"
            [ariaLabel]="'confirm' | translate"
            [label]="'confirm' | translate"
            (click)="closeBatchDialog.onAccept()"
          >
          </p-button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog
    #closeMergeDialog
    key="closeMergeDialog"
  >
    <ng-template
      let-message
      pTemplate="headless"
    >
      <div class="confirm-container">
        <div>
          <p>{{ message.message | translate }}</p>
        </div>
        <div class="buttons-container">
          <p-button
            class="dap-cancel-merge cancel-button"
            variant="text"
            [ariaLabel]="'cancel' | translate"
            [label]="'cancel' | translate"
            (click)="closeMergeDialog.onReject()"
          >
          </p-button>

          <p-button
            class="dap-confirm-merge confirm-button"
            [ariaLabel]="'confirm' | translate"
            [label]="'confirm' | translate"
            (click)="closeMergeDialog.onAccept()"
          >
          </p-button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog
    #deleteBatchConfirmDialog
    key="deleteBatchConfirmDialog"
    [header]="'warning' | translate"
  >
    <ng-template
      let-message
      pTemplate="message"
    >
      <div class="delete-confirm-container">
        <div class="">
          <p>{{ 'confirmDeleteBatchMessage' | translate }}</p>
          <p>{{ 'confirmDeleteBatchMessage2' | translate }}</p>
        </div>
      </div>
    </ng-template>
    <ng-template
      let-footer
      pTemplate="footer"
    >
      <div class="delete-confirm-buttons-container">
        <p-button
          class="dap-cancel-delete-batch cancel-button"
          variant="text"
          [label]="'cancel' | translate"
          (click)="deleteBatchConfirmDialog.onReject()"
        >
        </p-button>

        <p-button
          class="dap-confirm-delete-batch confirm-button"
          severity="danger"
          variant="outlined"
          [label]="'deleteBatch' | translate"
          (click)="deleteBatchConfirmDialog.onAccept()"
        >
        </p-button>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog
    #deleteBatchesConfirmDialog
    key="deleteBatchesConfirmDialog"
    [header]="'deleteBatches' | translate"
  >
    <ng-template
      let-message
      pTemplate="message"
    >
      <div
        class="delete-confirm-container delete-batches-message"
        [innerHTML]="message.message"
      ></div>
    </ng-template>
    <ng-template
      let-footer
      pTemplate="footer"
    >
      <div class="delete-confirm-buttons-container">
        <p-button
          class="dap-cancel-delete-batches cancel-button"
          variant="text"
          [label]="'cancel' | translate"
          (click)="deleteBatchesConfirmDialog.onReject()"
        >
        </p-button>

        <p-button
          class="dap-confirm-delete-batches confirm-button"
          severity="danger"
          variant="outlined"
          [label]="'delete' | translate"
          (click)="deleteBatchesConfirmDialog.onAccept()"
        >
        </p-button>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog
    #deleteBatchFileConfirmDialog
    key="deleteBatchFileConfirmDialog"
    [header]="'warning' | translate"
  >
    <ng-template
      let-message
      pTemplate="message"
    >
      <div class="delete-confirm-container">
        <div class="">
          <p>{{ 'confirmDeleteBatchFileMessage' | translate }}</p>
          <p>{{ 'confirmDeleteBatchFileMessage2' | translate }}</p>
        </div>
      </div>
    </ng-template>
    <ng-template
      let-footer
      pTemplate="footer"
    >
      <div class="delete-confirm-buttons-container">
        <p-button
          class="cancel-button"
          variant="text"
          [label]="'cancel' | translate"
          (click)="deleteBatchFileConfirmDialog.onReject()"
        >
        </p-button>

        <p-button
          class="confirm-button"
          severity="danger"
          variant="outlined"
          [label]="'deleteDocument' | translate"
          (click)="deleteBatchFileConfirmDialog.onAccept()"
        >
        </p-button>
      </div>
    </ng-template>
  </p-confirmDialog>

  <p-confirmDialog
    #deleteAdHocFileConfirmDialog
    key="deleteAdHocFileConfirmDialog"
    [header]="'warning' | translate"
  >
    <ng-template
      let-message
      pTemplate="message"
    >
      <div class="delete-confirm-container">
        <div class="">
          <p>{{ 'deleteDocumentMessage' | translate }}</p>
          <p>{{ 'confirmDeleteDocument' | translate }}</p>
        </div>
      </div>
    </ng-template>
    <ng-template
      let-footer
      pTemplate="footer"
    >
      <div class="delete-confirm-buttons-container">
        <p-button
          class="dap-cancel-adhoc cancel-button"
          variant="text"
          [label]="'cancel' | translate"
          (click)="deleteAdHocFileConfirmDialog.onReject()"
        >
        </p-button>

        <p-button
          class="dap-confirm-delete-adhoc confirm-button"
          severity="danger"
          variant="outlined"
          [label]="'deleteDocument' | translate"
          (click)="deleteAdHocFileConfirmDialog.onAccept()"
        >
        </p-button>
      </div>
    </ng-template>
  </p-confirmDialog>
}
